import { Get, Post, getAPIUrl } from "../../../services/apiMethod";

export const StateCityEndpoint = {
  getstate: `/admin/getState`,
  getCity: `/admin/getCity?`,
  addState: `/admin/addState`,
  addCity: `/admin/addCity`,
};

export const getstate = (param = "") => {
  const url = getAPIUrl(StateCityEndpoint.getstate, param);
  return Get(url);
};
export const getCity = (param = "") => {
  const url = getAPIUrl(StateCityEndpoint.getCity, param);
  return Get(url);
};

export const addState = (data, param = "") => {
  const url = getAPIUrl(StateCityEndpoint.addState, param);
  return Post(url, data, true);
};
export const addCity = (data, param = "") => {
  const url = getAPIUrl(StateCityEndpoint.addCity, param);
  return Post(url, data, true);
};
